import { render, staticRenderFns } from "./product-order.vue?vue&type=template&id=7f2ab89c&scoped=true"
import script from "./product-order.vue?vue&type=script&lang=js"
export * from "./product-order.vue?vue&type=script&lang=js"
import style0 from "./product-order.vue?vue&type=style&index=0&id=7f2ab89c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2ab89c",
  null
  
)

export default component.exports